import reserveApi from '../utils/axios'
import camelcaseKeys from 'camelcase-keys'

function fetchAdmin(path, type) {
  return dispatch => {
    return reserveApi({
      method: 'get',
      url: `/admin/${path}.json`
    })
      .then(response => {
        dispatch({
          type,
          payload: camelcaseKeys(response.data, { deep: true })
        })
      })
      .catch(err => {})
  }
}

export const fetchAdminAvailabilityRequestMatches = () =>
  fetchAdmin('/availability_requests/matches', 'FETCH_ADMIN_AVAILABILITY_REQUEST_MATCHES_FULFILLED')

export const fetchAdminAvailabilityRequestNotifications = () =>
  fetchAdmin('/availability_requests/notifications', 'FETCH_ADMIN_AVAILABILITY_REQUEST_NOTIFICATIONS_FULFILLED')

export function fetchAdminAvailabilityRequestStats(value) {
  return dispatch => {
    return reserveApi({
      method: 'get',
      url: '/admin/availability_requests.json'
    })
      .then(response => {
        dispatch({
          type: 'FETCH_ADMIN_AVAILABILITY_REQUEST_STATS_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {})
  }
}

export function fetchAdminAvailabilityMatchStats(value) {
  return dispatch => {
    return reserveApi({
      method: 'get',
      url: '/admin/availability_matches.json'
    })
      .then(response => {
        dispatch({
          type: 'FETCH_ADMIN_AVAILABILITY_MATCH_STATS_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {})
  }
}
export function fetchAdminUserStats(value) {
  return dispatch => {
    return reserveApi({
      method: 'get',
      url: '/admin/users.json'
    })
      .then(response => {
        dispatch({
          type: 'FETCH_ADMIN_USER_STATS_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {})
  }
}

export function fetchAdminPaymentChartMonthly(value) {
  return dispatch => {
    return reserveApi({
      method: 'get',
      url: '/admin/payments/chart/monthly.json'
    })
      .then(response => {
        dispatch({
          type: 'FETCH_ADMIN_PAYMENT_CHART_MONTHLY_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {})
  }
}

export function fetchAdminPaymentChartDaily(value) {
  return dispatch => {
    return reserveApi({
      method: 'get',
      url: '/admin/payments/chart/daily.json'
    })
      .then(response => {
        dispatch({
          type: 'FETCH_ADMIN_PAYMENT_CHART_DAILY_FULFILLED',
          payload: response.data
        })
      })
      .catch(err => {})
  }
}

export function getUsers(q = undefined) {
  return dispatch => {
    reserveApi({
      method: 'get',
      url: '/admin/users',
      params: { q }
    }).then(response => {
      dispatch({
        type: 'FETCH_ADMIN_USERS_FULFILLED',
        payload: camelcaseKeys(response.data, { deep: true })
      })
    })
  }
}

export function getUser(id) {
  return dispatch => {
    reserveApi({
      method: 'get',
      url: `/admin/users/${id}`,
    }).then(response => {
      dispatch({
        type: 'FETCH_ADMIN_USER_FULFILLED',
        payload: camelcaseKeys(response.data, { deep: true })
      })
    })
  }
}

export function addSms(id) {
  return dispatch => {
    reserveApi({
      method: 'post',
      url: `/admin/users/${id}/add_sms`,
    }).then(response => {
      dispatch({
        type: 'FETCH_ADMIN_USER_FULFILLED',
        payload: camelcaseKeys(response.data, { deep: true })
      })
    })
  }
}

export function premiumWelcome(id) {
  return dispatch => {
    reserveApi({
      method: 'post',
      url: `/admin/users/${id}/premium_welcome`,
    }).then(response => {
      dispatch({
        type: 'FETCH_ADMIN_USER_FULFILLED',
        payload: camelcaseKeys(response.data, { deep: true })
      })
    })
  }
}
